<template>
	<div class="insideBody">
		<div class="learnSelection">
			<div class="singleChoice">查询类型（单选）</div>
			<div class="top_ul">
				<div class="list clr" v-for="(item,index) in typedata" :key="index" :class="{'on':item.type == type}" @click="type = item.type">
					<img class="img fl" :src="require('../../assets/images/xqxh'+(item.type+2)+'.png')">
					<div class="tit">{{item.name}}</div>
				</div>
			</div>
			
			<div class="end_result">
				
				<div class="list" v-for="(item,index) in data" :key="index">
					<div class="top clr">
						<div class="tit fl">{{item.time + item.testname}}</div>
						<div class="del fr" @click="dodel(item,index)">删除</div>
						<div class="print fr" @click="exportword(item,{id:0})">打印空白试卷</div>
					</div>
					<div class="end" v-if="item.testdetail.length > 0">
						<div v-for="(items,indexs) in item.testdetail" :key="indexs">
							<ul>
								<li>{{indexs == 0?'学前':'学后'}}</li>
								<li>{{items.result}}</li>
								<li class="corgreen" @click="gettesterrword(items)" :class="{'on': items.gettesterrwordblon}">错词表<i></i></li>
								<li class="corgreen" @click="gettestdetail(item,items,'details')">查看试卷</li>
								<li class="corgreen" @click="gettestdetail(item,items,'answer')">答案</li>
								<li class="corgreen" @click="gettestdetail(item,items,'retest')">重测</li>
								<li class="corgreen" @click="exportword(item,items)">打印</li>
							</ul>
							<div class="conceals" v-for="(items,indexs) in item.testdetail" :key="indexs" :class="{'on': items.gettesterrwordblon}">
								<div class="tits">错词表</div>
								<dl v-for="(itema,indexa) in items.gettesterrworddata" :key="indexa">
									<dd>{{itema.word_spell}}</dd>
									<dd><i @click="audioFun(itema)" :class="{'on':itema.apply_blon}"></i>{{itema.word_symbol}}</dd>
									<dd>{{itema.word_meaning}}</dd>
								</dl>
								<div class="btn_list">
									<div class="btn" @click="items.gettesterrwordblon = false">收起</div>
								</div>
							</div>
						</div>
					</div>
					
				</div>
				
			</div>

		</div>
	</div>
</template>
<script>
import {gettestbytype,gettesterrword,dodel,gettestdetail,exportword} from '@/api/control1'
export default {
  data(){
    return {
			height: null,
			type: 1,
			typedata:[
				{
					type: 1,
					name:'教材版单词'
				},
				{
					type: 2,
					name:'升学版单词'
				}
			],
			data:[],
			list: 0,
			show: false,
			show2: false
		};
	},
	created(){
	},
	methods:{
		gettestdetail(item,items,name){
			var that = this,routeData = this.$router.resolve({
			  path: '/examination?lrid='+item.id+'&ltid='+items.id+'&name='+name+'&testname='+item.testname,
			});
			window.open(routeData.href, '_blank');
			// gettestdetail({
			// 	userid: that.utils.storageGet("userinfo").userid,
			// 	lrid: items.id,
			// 	ltid: item.id,
			// }).then(res => {
			// 	that.$message.success('获取成功');
			// });
		},
		exportword(item,items){
			var that = this;
			exportword({
				userid: that.utils.storageGet("userinfo").userid,
				lrid: item.id,
				ltid: items.id,
			}).then(res => {
				window.location.href = that.$url+'static/temp/'+res;
			});
		},
		dodel(item,index){
			var that = this;
			that.$confirm('此操作删除, 是否继续?', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
			}).then(() => {
				dodel({
					userid: that.utils.storageGet("userinfo").userid,
					ltid: item.id
				}).then(res => {
					that.data.splice(index,1);
					that.$message.success('删除成功');
				});
			}).catch(() => {
			  
			});
		},
		audioFun(item){
			var that = this;
			that.$set(item, 'apply_blon', true);
			that.utils.wordAudio(item.word_spell,item);
		},
		gettesterrword(item){
			var that = this;
			if(item.gettesterrwordblon){
				item.gettesterrwordblon = false;
				return false;
			};
			gettesterrword({
				userid: that.utils.storageGet("userinfo").userid,
				ltid: item.id
			}).then(res => {
				that.$set(item, 'gettesterrwordblon', true);
				that.$set(item, 'gettesterrworddata', res);
			});
		},
		gettestbytype(type){
			var that = this;
			gettestbytype({
				userid: that.utils.storageGet("userinfo").userid,
				type: type
			}).then(res => {
				that.data = res;
			});
		}
	},
	mounted(){
		var that = this;
		
	},
	components: {
		
	},
	watch: {
		type: {
		  handler: function(val){
		    var that = this;
		    that.gettestbytype(val);
		  },
		  deep: true,
			immediate: true
		}
	}
}
</script>
<style scoped>
	
</style>